import api from './api';

export const commentService = {
  saveComment: async (tabId, content, ticketId) => {
    const commentData = {
      tab_id: tabId,
      content: content,
      ticket_id: ticketId,
    };

    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
      maxContentLength: Infinity,
      maxBodyLength: Infinity,
    };

    const response = await api.post('/comments/addComment', commentData, config);
    return response.data;
  },

  getCommentsForTab: async (ticketId, tabId) => {
    const response = await api.get(`/comments/getComments/${ticketId}/${tabId}`);
    return response.data;
  },

  deleteComment: async (commentId) => {
    const response = await api.delete(`/comments/deleteComment/${commentId}`);
    return response.data;
  },

  getQuota: async (ticketId) => {
    const response = await api.get(`/comments/quota/${ticketId}`);
    return response.data;
  }
};